// expiration-date.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const EXPIRATION_DATE_INVALID = 'expirationDateInvalid';

export function expirationDateValidator(monthField: string, yearField: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const monthValue = group.get(monthField)?.value;
    const yearValue = group.get(yearField)?.value;

    // If either field is missing, do not validate.
    if (!monthValue || !yearValue) {
      return null;
    }

    // Parse month (accepts both "03" and "3")
    const monthInt = parseInt(monthValue, 10);
    if (isNaN(monthInt) || monthInt < 1 || monthInt > 12) {
      // Let other validators handle formatting errors.
      return null;
    }

    // Parse year and adjust if two-digit year is provided.
    let yearInt = parseInt(yearValue, 10);
    if (isNaN(yearInt)) {
      return null;
    }
    if (yearValue.toString().length === 2) {
      yearInt += 2000;
    }

    // Get current date values.
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    // Check that the expiration date is either in the current month or a future date.
    if (yearInt > currentYear || (yearInt === currentYear && monthInt >= currentMonth)) {
      return null;
    }

    return { [EXPIRATION_DATE_INVALID]: true };
  };
}
